(function ($, Drupal) {
  'use strict';

  // global vars
  var medium = 641;
  var desktop = 1024;
  var allowFollowLetters = ["", " ", ".", ",", "!", "?", ";", ":", "\"", "'", "“", "”", "‘", "’", "„", "‛", "‚"];

  Drupal.behaviors.nsbGlossar = {
    attach: function (context, settings) {
    }
  };

  $(document).ready(function () {
    var textElements = $('div.field.text-formatted p, div.field.text-formatted li');
    var glossarStack = globalGlossarStack.sort(function (a, b) {
      return b.word.indexOf(" ");
    });
    textElements.each(function (index, el) {
      var textElement = $(el);
      var oldhtml = remove_html_tag("span", textElement.html());
      var removers = [];

      //prepare Word replacement place info
      $.each(glossarStack, function (i, e) {

        if (!e.founded) {
          var newRemovePos = findWord(oldhtml, e.word, e);
          if (!e.founded) {
            var wordSmallFirstLetter = smallFirstLetter(e.word);
            newRemovePos = findWord(oldhtml, wordSmallFirstLetter, e);
          }
          if (!e.founded) {
            var pluralS = e.word + "s";
            newRemovePos = findWord(oldhtml, pluralS, e);
          }
          if (!e.founded) {
            var pluralSmallS = smallFirstLetter(e.word) + "s";
            newRemovePos = findWord(oldhtml, pluralSmallS, e);
          }
          if (!e.founded) {
            var pluralN = e.word + "n";
            newRemovePos = findWord(oldhtml, pluralN, e);
          }
          if (!e.founded) {
            var pluralSmallN = smallFirstLetter(e.word) + "n";
            newRemovePos = findWord(oldhtml, pluralSmallN, e);
          }
          if(newRemovePos != null){
            //no words in words
            var isNewWord = true;
            removers.forEach(function(remover){
              if((newRemovePos.indexStart >= remover.indexStart || newRemovePos.indexEnd >= remover.indexStart) && (newRemovePos.indexStart <= remover.indexEnd || newRemovePos.indexEnd <= remover.indexEnd)){
                isNewWord = false;
                e.founded = false;
              }
            });
            if(isNewWord) {
              removers.push(newRemovePos);
            }
          }
        }
      });

      if(removers.length > 0){
        removers = removers.sort(function (a, b) {
          return b.indexStart - a.indexStart;
        });
        removers.forEach(function(remover){
          oldhtml = oldhtml.substr(0, remover.indexStart) + "<a target='_blank' title='" + remover.description + "' class='glossar-item' rel='tooltip' href='/node/" + remover.nid + "'>" + remover.word + "</a>" + oldhtml.substr(remover.indexEnd);
        });
        textElement.html(oldhtml);
      }
    });
  });

  function findWord(text, word, e) {
    var indexStart = text.indexOf(word);
    var indexEnd = indexStart + word.length;
    if (indexStart > -1) {
      var letterBefore = "";
      if (indexStart > 0) {
        letterBefore = text.substring(indexStart - 1, indexStart);
      }
      var letterAfter = text.substring(indexEnd, indexEnd + 1);
      if ($.inArray(letterBefore, allowFollowLetters) > -1 && $.inArray(letterAfter, allowFollowLetters) > -1) {
        e.founded = true;
        return {
          "word": word,
          "description": e.description,
          "nid": e.nid,
          "indexStart": indexStart,
          "indexEnd": indexEnd
        }
      }
      else {
        return null;
      }
    }
  }

  function smallFirstLetter(string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
  }

  function remove_html_tag(tag, content) {
    var foundat = content.indexOf("<" + tag, foundat);
    while (foundat > -1) {
      var f2 = content.indexOf(">", foundat);
      if (f2 > -1) {
        content = content.substr(0, foundat) + content.substr(f2 + 1, content.length);
      }
      f2 = content.indexOf("</" + tag + ">", foundat);
      if (f2 > -1) {
        content = content.substr(0, f2) + content.substr(f2 + 3 + tag.length, content.length);
      }
      foundat = content.indexOf("<" + tag, foundat);
    }
    return content;
  }

})(jQuery, Drupal);